module.exports = require("@wildboar/ldap/src/lib/modules/Lightweight-Directory-Access-Protocol-V3/MatchingRuleAssertion.ta");